/**
 * Die Stufenspur einer Zeitstrahl-Zeile (`.tlp-cols` mit sechs `.tlp-node`) - Portierung von `track`
 * (`index.html:13742-13753`), erweitert um die zweite Quelle aus Verhaltensaenderung 6.
 *
 * ================= Zwei Quellen, eine Darstellungsgrammatik =================
 *
 * `spurfortschritt` liefert fuer jede Zeile denselben Satz Zahlen, egal woher er stammt:
 *
 * - **`quelle: "board"`** (keine verknuepfte Sendung, ODER eine verknuepfte Sendung ohne eine
 *   einzige verwertbare Station - siehe NACHBESSERUNG unten) - der Bestand: `erreicht` ist
 *   `orderStageIndex(o, definitionen)` (`index.html:13743`), `alleErreicht` ist
 *   `isArrivedStatus(o.status, definitionen)` (`index.html:13744`) - UNVERAENDERT, auch nach
 *   Auftrag 3 und der NACHBESSERUNG unten. Die Zeitpunkte kommen seit Auftrag 3 ("Hover-Datumswerte")
 *   aus `o.statusErstmals` (siehe `boardRueckfall` in `spurfortschritt` unten) - GENAUSO an BEIDEN
 *   Aufrufstellen von `boardRueckfall`, nicht nur bei fehlender Sendung; zuvor war dieser Zweig
 *   durchweg `null`.
 * - **`quelle: "dsv"`** (verknuepfte Sendung MIT mindestens einer verwertbaren Station) - `erreicht`
 *   und die Zeitpunkte kommen aus den gemeldeten Stationen, unveraendert seit Verhaltensaenderung 6;
 *   `erreicht` ist dabei nie `-1` (siehe NACHBESSERUNG unten).
 *
 * Die Zustandsableitung darunter (`done`/`current`/`todo`, die `.tlp-conn.on`-Regel, das Haekchen im
 * erledigten Knoten) ist in beiden Faellen WOERTLICH die des Originals (`index.html:13746-13751`).
 *
 * ================= Auftrag 3, "Hover-Datumswerte" =================
 *
 * Jeder Knoten traegt zusaetzlich eine Hover-Blase (`.tlp-tip`, `styles/neubau/zeitstrahlZeile.css`)
 * mit Stufenname und Datum (`fmtDate`) bzw. „noch nicht gemeldet"; dieselbe Zeichenkette liegt am
 * `.tlp-dot` als `aria-label` (das bisherige `title` entfaellt, sonst zwei Tooltips uebereinander).
 * `stufeFuerStatus` (`lib/zeitstrahlStufen.ts`) ist dieselbe Abbildung Status -> Stufe wie
 * `orderStageIndex` - eine zweite Kopie der Tabelle waere bei der naechsten Aenderung
 * auseinandergelaufen. Die sichtbare Datumszeile (`.tlp-station-datum`) steht an JEDEM Knoten, mit
 * seinem EIGENEN Zeitpunkt oder „—" (siehe NACHBESSERUNG "Nachtrag 2" unten) - die Hover-Blase
 * traegt denselben Text zusaetzlich noch einmal, fuer Maus-/Tastaturnutzer gleichermassen.
 *
 * NACHBESSERUNG (25.08.2026, "abgeschlossene Zeile") - AUFGEHOBEN, siehe NACHBESSERUNG "Nachtrag 2"
 * (2026-09-02) unten: zwischenzeitlich war GENAU EIN Knoten je Zeile sichtbar beschriftet (bevorzugt
 * der AKTUELLE, sonst der letzte mit Zeitpunkt) - eine ausdrueckliche Nutzerkorrektur am live
 * ausgerollten Stand hat diese Regel wieder rueckgaengig gemacht: jeder Knoten zeigt wieder seinen
 * eigenen Wert. Historisch stehen gelassen, weil sie den damaligen Beweggrund dokumentiert.
 *
 * ================= NACHBESSERUNG „Sammelroute nachbessern" (25.08.2026) =================
 *
 * Befund: `sendungAusTreffer` (`components/App/App.tsx`) bildet die `SendungsTreffer` der neuen
 * Sammelroute (Auftrag „Sammelroute fuer die Zeitstrahl-Liste") auf `Sendung` ab, OHNE `stationen` zu
 * setzen (die Sammelroute liefert keine rohen Stationsereignisse - siehe dortiger Kopfkommentar).
 * Vorher fiel `spurfortschritt` NUR bei `sendung === null` auf den Board-Status zurueck - jede
 * Bestellung mit verknuepfter, aber (noch) stationsloser Sendung bekam `quelle: "dsv"` mit
 * `erreicht: -1` und sechs leeren Zeitpunkten: KEIN Fortschrittsbalken, Absturz ans Listenende (die
 * Sortierung in `ZeitstrahlSeite.tsx` haengt an `erreicht`), UND die Zeile wies sich faelschlich als
 * „echte DSV-Daten" aus (`.tlp-quelle-dsv`). Schlechter als der Zustand ganz ohne Sammelroute.
 *
 * Fix: `erreicht === -1` (Regel 4 unten, unveraendert: keine Station ergab eine bekannte Stufe) heisst jetzt
 * IMMER Board-Rueckfall - unabhaengig davon, ob `sendung.stationen` fehlt/leer ist, oder ob keine der
 * vorhandenen Stationen eine bekannte Stufe ergab (Regel 3 unten schaltet in beiden Unterfaellen
 * nichts weiter). `quelle: "dsv"` mit `erreicht: -1` kann seither NICHT mehr vorkommen.
 *
 * Kein Paritaetstest in `frontend/test/parity/` haengt an `spurfortschritt` oder `track`
 * (`index.html:13742-13753`) - das Original kennt eine verknuepfte Sendung an dieser Stelle gar
 * nicht (`sendung` war dort immer implizit `null`, DSV-Daten kamen erst mit Verhaltensaenderung 6
 * hinzu). Der Riegel oben ist deshalb eine BEWUSSTE VERBESSERUNG ohne Vorbild, kein Paritaetsbruch.
 *
 * NACHBESSERUNG (Merge `main` -> `feat/zeitstrahl-sprechend`, Auftrag 9 "boardRueckfall und
 * statusErstmals zusammenfuehren"): `boardRueckfall` (unten) kam aus `main` mit fest `zeitpunkte:
 * SHIP_STAGES.map(() => null)` - unsere Seite (Auftrag 3, "Hover-Datumswerte") wertete an der
 * EINEN damaligen Rueckfallstelle (`!sendung`) bereits `o.statusErstmals` aus. Entscheidung: die
 * Datumsquelle gehoert IN `boardRueckfall` hinein, nicht daneben - sie gilt jetzt an BEIDEN
 * Aufrufstellen. Eine Sendung ohne verwertbare Station (der Fall, den die NACHBESSERUNG oben erst
 * ermoeglicht) zeigt seither die Datumswerte ihres Board-Verlaufs statt sechs leerer Stufen -
 * derselbe Rueckfall wie ohne Sendung, nur mit einer Sendung, die nichts beizutragen hatte.
 * `erreicht`/`alleErreicht` bleiben in JEDEM `boardRueckfall`-Aufruf ausschliesslich aus dem
 * Board-Status (`orderStageIndex`/`isArrivedStatus`) - der Verlauf liefert NUR Datumswerte, nie
 * Fortschritt (Testfall "zurueckgesetzte Bestellung").
 *
 * ================= Regeln der DSV-Quelle (aus dem DSV-Plan, nicht erfunden) =================
 *
 * `docs/superpowers/plans/2026-08-09-phase-04b-dsv.md`, Task 5 ("Festlegungen dieses Plans"):
 * 1. Die sechs Stufen und ihre IDs sind die des Bestands (`SHIP_STAGES`) - hier dieselbe Konstante,
 *    kein zweites Stufenmodell.
 * 2. Erreicht wird eine Stufe vom **fruehesten** Ereignis ihrer Station - eine Stufe wandert nicht.
 * 3. Eine **unbekannte Station schaltet nichts weiter** - sie erfindet keinen Fortschritt.
 * 4. `erreicht === -1`, solange keine Station gemeldet ist. Seit der NACHBESSERUNG oben heisst das:
 *    Board-Rueckfall statt eines Knotens ohne `current` unter der Flagge "dsv".
 *
 * ANNAHME (im Task-Bericht als offener Punkt gefuehrt): Der Brief liefert die Stationscodes
 * `abgeholt` und `verschifft`, der DSV-Plan die Stationsnamen `Gebucht`, `Abgangshafen`,
 * `Haupttransport gestartet`, `Empfangshafen`, `Importverzollung`, `Geliefert` - zwei Benennungen
 * derselben Sache. `STATIONSCODE_ZU_STUFE` unten fuehrt beide plus die Stufen-IDs selbst. Die
 * REALEN Codes des Fremdsystems sind laut DSV-Plan (offene Frage U2, dort Task 3) noch unbekannt;
 * diese Tabelle ist die einzige Stelle, an der sie nachzuziehen sind.
 *
 * ================= Auftrag "Zeitstrahl-Uebersicht: ETD/ETA-Labels und Datumsquelle fuer
 * Flug-Sendungen" (28.08.2026, Asana-Ticket "Zeitstrahl bei Flug-Sendungen") =================
 *
 * URSPRUENGLICH ZWEI ANGRENZENDE, ABER GETRENNTE AENDERUNGEN, beide NUR fuer
 * `o.transportMode === "air"`:
 *
 * 1. BESCHRIFTUNG: `ETA_ETD_LABEL_UEBERSCHREIBUNG` unten ersetzt in der ZEILEN-Anzeige (Hover-Blase,
 *    `aria-label`) "See" durch "ETD" und "Hafen DE" durch "ETA" - "ABSINA" bleibt "ABSINA" (kein
 *    Eintrag noetig). Die interne Stufen-ID (`s.id`, `"see"`/`"hafen_de"`) und `SHIP_STAGES` selbst
 *    bleiben UNVERAENDERT - nur der angezeigte Text wandert. Bewusst NICHT an der Stelle geaendert,
 *    an der `ZeitstrahlSeite.tsx` den globalen Legende-/Spaltenkopf rendert
 *    (`.tlp-legend`/`.tlp-cols` in `tlp-grid-head`): DIESE Kopfzeile steht genau EINMAL ueber der
 *    GESAMTEN, typischerweise gemischten Liste (See- und Flug-Bestellungen nebeneinander, Vorgabe
 *    `TRANSPORTARTFILTER_VORGABE = { see: true, air: true }`) und konnte damals nicht gleichzeitig
 *    "SEE" und "ETD" fuer verschiedene Zeilen zeigen.
 *
 *    KORREKTUR (Folgeauftrag "Uebersichtsseite Zeitstrahl - Hafen DE zu ETA und See zu ETD",
 *    Asana-Ticket 1218051183819571, 2026-09-01): genau DAS oben beschriebene Problem hat der
 *    Auftraggeber per Rueckfrage aufgeloest, nicht umgangen - die globale Kopfzeile zeigt seither
 *    UNBEDINGT "ETD"/"ETA" (`ETA_ETD_LABEL_UEBERSCHREIBUNG.get(s.id) ?? s.label` in
 *    `ZeitstrahlSeite.tsx`, `.tlp-legend` UND `.tlp-col-lbl`), UNABHAENGIG von der Transportart der
 *    Zeilen darunter - auch bei einer rein aus See-Bestellungen bestehenden Liste. NUR die einzelnen
 *    ZEILEN (Hover-Blase `.tlp-tip` + `aria-label` an `.tlp-dot`, `Stationsspur` unten) unterscheiden
 *    WEITERHIN nach `transportMode` wie zuvor - See-Zeilen zeigen dort weiter "See"/"Hafen DE",
 *    Flug-Zeilen "ETD"/"ETA". Beide Stellen nutzen dieselbe, jetzt exportierte Map (keine zweite,
 *    driftende Tabelle).
 * 2. DATUMSQUELLE: `mitHandUeberschreibung` unten ersetzt bei `spurfortschritt()` die Zeitpunkte der
 *    drei Knoten "see"/"hafen_de"/"absina" durch `o.airEtd`/`o.airEta`/`o.airAbsina`
 *    (`order_extras.air_etd/air_eta/air_absina`, dieselben Felder, die der Speditionstab ueber
 *    "Ändern" pflegt, `Drawer/ShipTab/Stationen.tsx`) - statt der bisherigen Berechnung aus
 *    `sendung.stationen[]`/`o.statusErstmals`. NUR die angezeigten ZEITPUNKTE wandern; `erreicht`/
 *    `alleErreicht`/`quelle` (Fortschritt, Haekchen, Sortierung) bleiben UNVERAENDERT aus der
 *    bestehenden Berechnung - der Auftrag verlangt nur "die Knoten ... anzeigen", nicht eine zweite
 *    Fortschrittslogik, und "Status-Dropdown (Gebucht/Unterwegs/Angekommen) bleibt unveraendert" ist
 *    ausdruecklich NICHT Teil des Auftrags. Ein `null`/`undefined`-Feld (noch nicht manuell
 *    bestaetigt) ergibt weiterhin "noch nicht gemeldet" - dasselbe bestehende Tooltip-Muster.
 *
 * ================= DRITTE Transportart "road" (Asana-Ticket 1218176179911324,
 * "Zusaetzlicher LKW Speditionstyp") =================
 *
 * Derselbe Bauplan wie "air" oben, aber mit nur ZWEI Handfeldern (`o.roadEtd`/`o.roadEta`, keine
 * Zwischenstation): `stufenLabel` ueberschreibt bei "road" GENAU EINEN Knotennamen ("see" -> "Abfahrt",
 * `ROAD_LABEL_UEBERSCHREIBUNG` unten, eine EIGENE, lokale Map statt eines weiteren Eintrags in
 * `ETA_ETD_LABEL_UEBERSCHREIBUNG` - die bleibt UNANGETASTET, siehe deren Kopfkommentar: sie wird von
 * `ZeitstrahlSeite.tsx` zusaetzlich UNBEDINGT fuer die globale Kopfzeile/Legende genutzt, ein Eintrag
 * mehr dort wuerde die Legende fuer ALLE Bestellungen umbenennen, nicht nur road-Zeilen).
 * `mitHandUeberschreibung` schreibt bei "road" zwei Zeitpunkte statt drei: "see" <- `roadEtd`,
 * "absina" <- `roadEta`. Die Stufen "hafen_ab"/"hafen_de"/"zoll" behalten bei road bewusst ihre
 * Bestandsbeschriftung ("Hafen CN"/"Hafen DE"/"Zoll") - sie kommen aus dem Board-Status, nicht aus
 * der Transportart, und ein LKW hat ohnehin keinen Hafen/keine Verzollung, die diese Knoten
 * anzeigen koennten.
 */
import { SHIP_STAGES, type ShipStage } from "../../config/shipping.ts";
import { fmtDate, normSearch } from "../../lib/format.ts";
import { isArrivedStatus, orderStageIndex, type StatusDefinitionen } from "../../lib/status.ts";
import type { Order, Sendung, Sendungsstation } from "../../lib/types.ts";
// NACHBESSERUNG (W3, Pruefung d4dd340): `stufeFuerStatus` kommt aus dem eigenen, nicht getrackten
// Modul `lib/zeitstrahlStufen.ts` - Begruendung dort.
import { stufeFuerStatus } from "../../lib/zeitstrahlStufen.ts";
import { Ikone } from "../Ikone.tsx";

/** Woher der Fortschritt einer Zeile stammt. */
export type Spurquelle = "dsv" | "board";

export interface Spurfortschritt {
  quelle: Spurquelle;
  /**
   * Index der aktuellen Stufe (`reached` im Original). `-1` heisst "keine Stufe erreicht" und kann
   * nur bei `quelle: "dsv"` auftreten - `orderStageIndex` liefert immer mindestens 0.
   */
  erreicht: number;
  /** Alle Knoten sind `done` (`done` im Original, `index.html:13744`). */
  alleErreicht: boolean;
  /**
   * Je Stufe der frueheste gemeldete Zeitpunkt, sonst `null`. Bei `quelle: "board"` aus
   * `o.statusErstmals` (Auftrag 3), bei `quelle: "dsv"` aus den Stationsdaten.
   */
  zeitpunkte: readonly (string | null)[];
}

/**
 * Stationsschluessel -> Stufen-ID aus `SHIP_STAGES`. Kleingeschrieben und getrimmt (`normSearch`),
 * damit die Schreibweise des Fremdsystems nichts entscheidet.
 *
 * Eine `Map` statt eines Objektliterals: ein Stationscode `constructor` oder `__proto__` aus einem
 * Fremdsystem darf keine Stufe weiterschalten. Der DSV-Plan loest dasselbe ueber einen
 * prototypenlosen Traeger mit `Object.hasOwn`; eine `Map` kennt die Prototypenkette gar nicht erst.
 */
export const STATIONSCODE_ZU_STUFE: ReadonlyMap<string, string> = new Map([
  // Brief (Fixture `SENDUNGEN`)
  ["abgeholt", "hersteller"],
  ["verschifft", "see"],
  // DSV-Plan, `STATION_ZU_STUFE`
  ["gebucht", "hersteller"],
  ["empfang der fracht", "hersteller"],
  ["abgangshafen", "hafen_ab"],
  ["haupttransport gestartet", "see"],
  ["empfangshafen", "hafen_de"],
  ["importverzollung", "zoll"],
  ["geliefert", "absina"],
  // NACHBESSERUNG (23.08.2026, "Stationszuordnung auf die gemessenen DSV-Ereigniscodes umstellen"),
  // nachgezogen fuer die Festlegung des Auftraggebers vom 25.08.2026 (Pruefung, Auflagen 1+2):
  // dieselben elf gemessenen eventCode-Kuerzel wie `STATION_ZU_STUFE` in
  // backend/src/dsv/feldzuordnung.ts - dieselbe Tabelle, ein zweites Mal gefuehrt, weil diese
  // Flaeche ihren Fortschritt selbst aus `sendung.stationen[].code` berechnet statt den fertigen
  // Zeitstrahl vom Backend zu uebernehmen (siehe Kopfkommentar). Bei einer Aenderung an einer der
  // beiden Tabellen IMMER die andere mitziehen (siehe dsv-stationscode-drift.test.ts im Backend).
  // irp/pcf stehen jetzt auf "hersteller" (nicht mehr "hafen_ab" - derselbe Meilenstein wie
  // "empfang der fracht"). ccc ("Import customs commenced") ist entfallen: "Zoll" bedeutet
  // VERZOLLT und schaltet nur noch bei clr ("Import customs cleared").
  ["booking", "hersteller"],
  ["irp", "hersteller"],
  ["pcf", "hersteller"],
  ["hnv_carr", "hafen_ab"],
  ["cci", "hafen_ab"],
  ["ecc", "hafen_ab"],
  ["dep", "see"],
  ["arv", "hafen_de"],
  ["clr", "zoll"],
  ["dcf", "absina"],
  ["ddi_pod", "absina"],
  // Die Stufen-IDs selbst, falls das Fremdsystem sie direkt meldet
  ...SHIP_STAGES.map((stufe) => [stufe.id, stufe.id] as [string, string]),
]);

function istStrasse(modus: unknown): boolean {
  return typeof modus === "string" && modus.trim().toLowerCase() === "road";
}

function unlocodeNormal(wert: unknown): string | null {
  const t = typeof wert === "string" ? wert.trim().toUpperCase() : "";
  return t === "" ? null : t;
}

/**
 * Regel fuer die Stufe "hafen_de" (Label "ETA"; Asana 1218738455897914) - DIESELBE Regel wie
 * `hafenDeZeitpunkt` in backend/src/dsv/zeitstrahl.ts (Drawer), bei einer Aenderung beide mitziehen:
 * Zielhafen = UN/LOCODE der zeitlich SPAETESTEN ETA-Station mit Ort; Datum = fruehestes ARV mit genau
 * diesem UN/LOCODE, ARV nur am Umladehafen zaehlt nicht (Stufe bleibt offen, `null`). Ohne ETA mit
 * Ort: spaetestes ARV mit Ort. Tragen die ARVs gar keinen Ort: fruehestes ARV (bisheriges Verhalten).
 * `stationen` traegt nur nicht stornierte Ereignisse (Backend, `istVerwertbaresEreignis`) - ETA
 * steht dort mit drin, schaltet aber selbst keine Stufe (nicht in `STATIONSCODE_ZU_STUFE`).
 */
export function hafenDeZeitpunkt(stationen: readonly Sendungsstation[]): string | null {
  const mitZeit = stationen
    .filter((s) => s?.zeitpunkt != null && !Number.isNaN(Date.parse(String(s.zeitpunkt))))
    .map((s) => ({ code: normSearch(s.code), zeitpunkt: String(s.zeitpunkt), unlocode: unlocodeNormal(s.unlocode), strasse: istStrasse(s.transportMode) }));
  const zeit = (x: { zeitpunkt: string }) => Date.parse(x.zeitpunkt);
  const frueh = (l: typeof mitZeit) => l.reduce((a, b) => (zeit(b) < zeit(a) ? b : a));
  const spaet = (l: typeof mitZeit) => l.reduce((a, b) => (zeit(b) > zeit(a) ? b : a));
  const arvs = mitZeit.filter((x) => x.code === "arv");
  if (arvs.length === 0) return null;
  const arvMitOrt = arvs.filter((x) => x.unlocode !== null);
  if (arvMitOrt.length === 0) return frueh(arvs).zeitpunkt;
  // Luftfracht (wie etaAusPayload/hafenDeZeitpunkt im Backend): Strassen-ETA nach der Landung zaehlt nicht,
  // sofern eine ETA mit anderem Verkehrstraeger existiert - entschieden ueber ALLE ETAs (mit oder ohne Ort).
  // Ohne transportMode: unveraendert.
  const etasGesamt = mitZeit.filter((x) => x.code === "eta");
  const nichtStrasseGesamt = etasGesamt.filter((x) => !x.strasse);
  const alleEtas = etasGesamt.filter((x) => x.unlocode !== null);
  const nichtStrasse = nichtStrasseGesamt.filter((x) => x.unlocode !== null);
  // Randfall: Flug-ETA ohne Ort, nur die Strassen-ETA hat einen. ETA ist Prognose und schaltet nie: keine
  // Markierung (null) statt falscher Station oder erfundenem Datum (ARV koennte eine Zwischenlandung sein).
  if (nichtStrasse.length === 0 && nichtStrasseGesamt.length > 0 && alleEtas.length > 0) {
    return null;
  }
  const etas = nichtStrasse.length > 0 ? nichtStrasse : alleEtas;
  if (etas.length === 0) return spaet(arvMitOrt).zeitpunkt;
  const ziel = spaet(etas).unlocode;
  const amZiel = arvMitOrt.filter((x) => x.unlocode === ziel);
  return amZiel.length === 0 ? null : frueh(amZiel).zeitpunkt;
}

/**
 * Label-Ueberschreibung "See" -> "ETD", "Hafen DE" -> "ETA" - urspruenglich (Auftrag
 * "Zeitstrahl-Uebersicht ETD/ETA", 28.08.2026) NUR fuer die Zeilen-Anzeige bei Flug-Bestellungen
 * (Hover-Blase/`aria-label`, siehe Kopfkommentar Punkt 1 und `stufenLabel` unten - dort weiterhin
 * NUR bei `transportMode === "air"`). Seit dem Folgeauftrag "Uebersichtsseite Zeitstrahl - Hafen DE
 * zu ETA und See zu ETD" (Asana-Ticket 1218051183819571, 2026-09-01) EXPORTIERT und zusaetzlich UNBEDINGT
 * von der globalen Kopfzeile/Legende in `ZeitstrahlSeite.tsx` genutzt (`.tlp-legend`/`.tlp-col-lbl`) -
 * deshalb der umbenannte, nicht mehr air-spezifische Name. Bewusst DIESELBE Map an beiden Stellen
 * (kein zweiter, driftender Eintrag) - dieselbe Vorsicht wie bei `STATIONSCODE_ZU_STUFE`/
 * `STATION_ZU_STUFE` oben. "absina" braucht keinen Eintrag: das Label ist ueberall bereits "ABSINA".
 */
export const ETA_ETD_LABEL_UEBERSCHREIBUNG: ReadonlyMap<string, string> = new Map([
  ["see", "ETD"],
  ["hafen_de", "ETA"],
]);

/**
 * Label-Ueberschreibung fuer "road" (Asana 1218176179911324): GENAU EIN Eintrag, "See" -> "Abfahrt" -
 * der LKW hat keine Zwischenstation, die "Hafen DE"/"ETA" entspraeche, deshalb bleibt dieser Knoten
 * bei road unbenannt (er zeigt `roadEta`, siehe `mitHandUeberschreibung`, aber unter seinem
 * Bestandsnamen "ABSINA"). Bewusst eine EIGENE, lokale Map statt eines dritten Eintrags in
 * `ETA_ETD_LABEL_UEBERSCHREIBUNG` - siehe Kopfkommentar, Abschnitt "DRITTE Transportart road".
 */
const ROAD_LABEL_UEBERSCHREIBUNG: ReadonlyMap<string, string> = new Map([["see", "Abfahrt"]]);

/**
 * Das anzuzeigende Label einer Stufe in der Zeile - "See"/"Hafen DE" werden bei Flug-Bestellungen
 * durch "ETD"/"ETA" ersetzt, "See" bei Straßen-Bestellungen durch "Abfahrt". Die Stufen "hafen_ab"/
 * "hafen_de"/"zoll" behalten bei road bewusst ihre Bestandsbeschriftung - sie kommen aus dem
 * Board-Status, nicht aus der Transportart (Kopfkommentar, Abschnitt "DRITTE Transportart road").
 */
function stufenLabel(s: ShipStage, transportMode: "see" | "air" | "road" | undefined): string {
  if (transportMode === "air") return ETA_ETD_LABEL_UEBERSCHREIBUNG.get(s.id) ?? s.label;
  if (transportMode === "road") return ROAD_LABEL_UEBERSCHREIBUNG.get(s.id) ?? s.label;
  return s.label;
}

/**
 * Ueberschreibt bei Flug-/Straßen-Bestellungen die manuell bestaetigten Handknoten mit den Feldern
 * der jeweiligen Transportart - siehe Kopfkommentar, Punkt 2 (air) bzw. Abschnitt "DRITTE
 * Transportart road". `erreicht`/`alleErreicht`/`quelle` bleiben in BEIDEN Faellen UNVERAENDERT, nur
 * `zeitpunkte` wandert - bei air an drei Indizes (ETD/ETA/ABSINA), bei road an zwei (Abfahrt/ABSINA).
 * EINE Funktion, die auf den Modus verzweigt, statt zwei fast gleiche nebeneinander.
 */
function mitHandUeberschreibung(o: Order, basis: Spurfortschritt): Spurfortschritt {
  if (o.transportMode !== "air" && o.transportMode !== "road") return basis;
  const zeitpunkte = [...basis.zeitpunkte];
  const setzen = (stufenId: string, wert: string | null | undefined): void => {
    const index = SHIP_STAGES.findIndex((s) => s.id === stufenId);
    if (index !== -1) zeitpunkte[index] = wert ?? null;
  };
  if (o.transportMode === "air") {
    setzen("see", o.airEtd);
    setzen("hafen_de", o.airEta);
    setzen("absina", o.airAbsina);
  } else {
    setzen("see", o.roadEtd);
    setzen("absina", o.roadEta);
  }
  return { ...basis, zeitpunkte };
}

/**
 * Der Fortschritt einer Zeile. Mit `sendung` aus den Stationsdaten, ohne sie aus dem Board-Status -
 * siehe Kopfkommentar. Bei Flug-/Straßen-Bestellungen greift zusaetzlich `mitHandUeberschreibung`
 * (Punkt 2 im Kopfkommentar) - `spurfortschrittRoh` bleibt dafuer unangetastet, die Ueberschreibung
 * sitzt an EINER Stelle statt an jedem der drei Rueckgabepunkte unten.
 */
export function spurfortschritt(
  o: Order,
  definitionen: StatusDefinitionen,
  sendung: Sendung | null,
): Spurfortschritt {
  return mitHandUeberschreibung(o, spurfortschrittRoh(o, definitionen, sendung));
}

function spurfortschrittRoh(
  o: Order,
  definitionen: StatusDefinitionen,
  sendung: Sendung | null,
): Spurfortschritt {
  // Board-Rueckfall (index.html:13743-13744, `erreicht`/`alleErreicht` unveraendert): keine
  // verknuepfte Sendung, ODER (siehe Kopfkommentar, Abschnitt NACHBESSERUNG) eine verknuepfte
  // Sendung ohne eine einzige verwertbare Station - der Aufruf unten (nach der Stationsschleife)
  // landet im selben Zweig. Auftrag 3 ("Hover-Datumswerte", zusammengefuehrt mit `main` in Auftrag
  // 9): die Zeitpunkte kommen aus `o.statusErstmals` - die dritte Quelle fuer die ZEITEN, nicht fuer
  // den Fortschritt. `erreicht`/`alleErreicht` bleiben wortgleich index.html:13743-13744,
  // ausschliesslich vom aktuellen Board-Status abgeleitet - wer sie aus dem Verlauf ableiten wuerde,
  // liesse eine zurueckgesetzte Bestellung faelschlich auf ihrer alten, spaeteren Stufe stehen.
  const boardRueckfall = (): Spurfortschritt => {
    const zeitpunkte: (string | null)[] = SHIP_STAGES.map(() => null);
    const statusErstmals = (o.statusErstmals as Record<string, unknown>) || {};
    for (const [status, ts] of Object.entries(statusErstmals)) {
      // Regel 3 (wie bei der DSV-Quelle): ein Status, den STATUS_STAGE nicht kennt, schaltet
      // nichts weiter - kein erfundener Fortschritt. `stufeFuerStatus` selbst faellt fuer einen
      // unbekannten Schluessel auf Stufe 0 zurueck; deshalb hier vorab pruefen.
      if (!Object.prototype.hasOwnProperty.call(definitionen.STATUS_STAGE, status)) continue;
      if (ts == null) continue;
      const zeitpunkt = String(ts);
      // NACHBESSERUNG (G3, Pruefung d4dd340): ein leerer oder nur aus Leerzeichen bestehender Wert
      // aus `order_history` lief bisher durch (`ts == null` faengt ihn nicht) und ergab ueber
      // `fmtDate("") === ""` einen Blasentext ohne Datum ("Hafen DE · " statt "noch nicht
      // gemeldet"). Wie ein fehlender Eintrag behandelt - NICHT dieselbe Stelle wie die
      // NaN-Asymmetrie in Regel 2 unten (bleibt unveraendert, gehoert zum parallelen Auftrag).
      if (zeitpunkt.trim() === "") continue;
      const index = stufeFuerStatus(status, definitionen);
      const bisher = zeitpunkte[index];
      // Regel 2, wortgleich zur DSV-Seite: das fruehste Ereignis gewinnt; ein unlesbares Datum
      // (NaN-Vergleich) verdraengt keinen lesbaren Wert.
      if (bisher === null || Date.parse(zeitpunkt) < Date.parse(bisher)) zeitpunkte[index] = zeitpunkt;
    }
    return {
      quelle: "board",
      // index.html:13743-13744, unveraendert: NUR Fortschritt, kein Datum.
      erreicht: orderStageIndex(o, definitionen),
      alleErreicht: isArrivedStatus(o.status, definitionen),
      zeitpunkte,
    };
  };

  if (!sendung) return boardRueckfall();

  const zeitpunkte: (string | null)[] = SHIP_STAGES.map(() => null);
  for (const station of sendung.stationen || []) {
    // ARV schaltet "hafen_de" nicht nach "fruehestes gewinnt", sondern ueber hafenDeZeitpunkt() unten.
    if (normSearch(station?.code) === "arv") continue;
    const stufe = STATIONSCODE_ZU_STUFE.get(normSearch(station?.code));
    if (stufe === undefined) continue; // Regel 3: unbekannte Station schaltet nichts weiter
    const index = SHIP_STAGES.findIndex((s) => s.id === stufe);
    if (index === -1) continue;
    if (station?.zeitpunkt == null) continue;
    const zeitpunkt = String(station.zeitpunkt);
    const bisher = zeitpunkte[index];
    // Regel 2: das frueheste Ereignis einer Station gewinnt. Bei unlesbarem Datum ist der Vergleich
    // NaN-behaftet und damit falsch - dann bleibt der zuerst gesehene Wert stehen, statt dass ein
    // unlesbares Datum ein lesbares verdraengt.
    if (bisher === null || Date.parse(zeitpunkt) < Date.parse(bisher)) zeitpunkte[index] = zeitpunkt;
  }

  const hafenDe = hafenDeZeitpunkt(sendung.stationen || []);
  if (hafenDe !== null) {
    const index = SHIP_STAGES.findIndex((s) => s.id === "hafen_de");
    const bisher = zeitpunkte[index];
    if (index !== -1 && (bisher === null || Date.parse(hafenDe) < Date.parse(bisher))) zeitpunkte[index] = hafenDe;
  }

  let erreicht = -1;
  zeitpunkte.forEach((zeitpunkt, index) => {
    if (zeitpunkt !== null) erreicht = index;
  });

  // NACHBESSERUNG (siehe Kopfkommentar): `stationen` fehlt/leer ODER keine davon ergab eine bekannte
  // Stufe - in BEIDEN Faellen bleibt `erreicht` hier bei -1. Ohne diesen Riegel meldete die Zeile
  // `quelle: "dsv"` mit `erreicht: -1` - keinen Fortschrittsbalken, Absturz ans Listenende, und die
  // faelschliche Kennzeichnung als "echte DSV-Daten".
  if (erreicht === -1) return boardRueckfall();

  return {
    quelle: "dsv",
    erreicht,
    // Die letzte Stufe ist ABSINA: ist sie gemeldet, ist die Sendung angekommen und alle Knoten sind
    // `done` - dieselbe Bedeutung, die `isArrivedStatus` auf der Board-Seite hat.
    alleErreicht: erreicht === SHIP_STAGES.length - 1,
    zeitpunkte,
  };
}

export interface StationsspurProps {
  fortschritt: Spurfortschritt;
  /**
   * `order.transportMode` (Auftrag "Zeitstrahl-Uebersicht ETD/ETA", 28.08.2026) - steuert NUR die
   * Beschriftung von Hover-Blase und `aria-label` (siehe Kopfkommentar, Punkt 1). Optional: eine
   * fehlende Angabe verhaelt sich wie `"see"` (Bestandsverhalten, keine Regression fuer Aufrufer
   * ohne dieses Prop).
   */
  transportMode?: "see" | "air" | "road";
}

/** index.html:13745-13752 - die sechs Knoten einer Zeile. */
export function Stationsspur({ fortschritt, transportMode }: StationsspurProps) {
  const { alleErreicht, erreicht, zeitpunkte } = fortschritt;
  // NACHBESSERUNG (Nachtrag 2 zu 96075fe/9d07dd4, 2026-09-02, Nutzerkorrektur am live ausgerollten
  // Stand): die vorherige "GENAU EIN Datum je Zeile"-Regel (25.08.2026, per `sichtbarerIndex`/
  // `hatAktuellenKnoten` - AKTUELLER Knoten, sonst der letzte mit Zeitpunkt, alle uebrigen nur ueber
  // die Hover-Blase) ist damit AUSDRUECKLICH aufgehoben, nicht nur ersetzt: der Nutzer will jeden der
  // sechs Punkte einzeln beschriftet sehen ("es sollen alle punkte beschriftet sein"), nicht nur
  // einen. Jeder Knoten zeigt jetzt direkt seinen EIGENEN Zeitpunkt (`zeitpunkte[i]`, siehe unten) -
  // die gesamte `sichtbarerIndex`-Berechnung (Rueckfallschleife samt der `alleErreicht`-Sonderregel
  // aus dem vorigen Nachtrag) entfaellt ersatzlos: `state` (done/current/todo) haengt ohnehin schon
  // direkt an `erreicht`/`alleErreicht`, nichts anderes im Rumpf unten griff auf `sichtbarerIndex` zu.
  return (
    <div className="tlp-cols">
      {SHIP_STAGES.map((s, i) => {
        const state = alleErreicht || i < erreicht ? "done" : i === erreicht ? "current" : "todo";
        const zeitpunkt = zeitpunkte[i];
        // Auftrag 3 ("Hover-Datumswerte"): Text der Hover-Blase UND des `aria-label` - dieselbe
        // Zeichenkette, einzeilig (harte Auflage: die Blase darf nicht ueber die Zeile hinausragen,
        // siehe `zeitstrahlZeile.css`). Auftrag "Zeitstrahl-Uebersicht ETD/ETA" (28.08.2026):
        // `stufenLabel` ersetzt bei Flug-Bestellungen "See"/"Hafen DE" durch "ETD"/"ETA" (Kopfkommentar,
        // Punkt 1) - `s.id` und `SHIP_STAGES` selbst bleiben unangetastet.
        const label = stufenLabel(s, transportMode);
        const tipText = `${label} · ${zeitpunkt === null ? "noch nicht gemeldet" : fmtDate(zeitpunkt)}`;
        return (
          <div className={`tlp-node ${state}`} key={s.id}>
            {i > 0 ? (
              <div className={`tlp-conn ${alleErreicht || i <= erreicht ? "on" : ""}`} />
            ) : (
              <div className="tlp-conn spacer" />
            )}
            {/*
              `title` entfaellt (Auftrag 3): mit der Hover-Blase daneben erschienen sonst zwei
              Tooltips uebereinander. `aria-label` traegt denselben Text wie die Blase weiter -
              NACHBESSERUNG (G2, Pruefung d4dd340): ein `aria-label` an einem rollenlosen `<div>`
              (`role=generic`) ist laut ARIA nicht namensfaehig und wird von Screenreadern
              ignoriert. `role="img"` macht den Punkt namensfaehig - er IST eine Grafik, die einen
              Zustand traegt.
            */}
            <div className="tlp-dot" role="img" aria-label={tipText}>
              {/*
                Task 6 (Verdrahtungsplan Phase 6): `<i data-lucide="check">` -> `Ikone` - eine der
                vier Fundstellen im ganzen `src/`, die niemand hydriert (siehe Kopfkommentar).
              */}
              {state === "done" ? <Ikone name="check" /> : i + 1}
            </div>
            <div className="tlp-tip">{tipText}</div>
            {/*
              Der Platz fuer die sichtbare Datumszeile ist bei JEDEM Knoten reserviert
              (`.tlp-station-datum` in `zeitstrahlZeile.css` traegt seit der W2-Nachbesserung eine
              FESTE `height` statt `min-height`, siehe dortiger Kommentar - seit "Zeitstrahl-Datum
              groesser" 15px statt 11px), sonst spraenge die Zeilenhoehe und die Punkte laegen nicht
              mehr auf einer Linie.

              NACHBESSERUNG (Nachtrag 2, 2026-09-02, Nutzerkorrektur): JEDER Knoten zeigt jetzt seinen
              EIGENEN Zeitpunkt - die vorherige "GENAU EIN Datum je Zeile"-Regel (bevorzugt der
              AKTUELLE Knoten, sonst der letzte mit Zeitpunkt, alle uebrigen nur ueber die Hover-Blase)
              ist aufgehoben (siehe Kopfkommentar der Funktion). `fmtDate(zeitpunkt) || "—"` - bereits
              der gepruefte, robuste Musterausdruck aus der vorherigen Pruefrunde (Nachtrag zu
              96075fe, Punkt 2): `fmtDate(null)` liefert `""` (`lib/format.ts`, `d ? ... : ""`),
              ebenso `fmtDate("")` (moeglich laut Kommentar oben in `boardRueckfall` - dort zu
              `continue` normalisiert, `spurfortschrittRoh`s DSV-Zweig hat dieselbe Sperre NICHT) - ein
              leerer String ist falsy, `|| "—"` faengt beide Faelle einheitlich ab. Dasselbe Zeichen
              wie im Drawer (`ShipTab/Stationen.tsx`, `stufe.erreichtAm ? fmtDate(...) : "—"`).

              NACHBESSERUNG (Nachtrag 4, 2026-09-02, Pruefung nach 70228ed4): der Text steht in einem
              INNEREN `<span>` statt direkt im `<div class="tlp-station-datum">` - EMPIRISCH GEPRUEFT
              (playwright-core, isoliertes Minimalbeispiel): `text-align: center` allein zentriert nur
              den UNBESCHNITTENEN Text; sobald die Zeile ueberhaupt breiter als ihre Box wird (nicht
              erst durch `text-overflow: ellipsis`, siehe RICHTIGSTELLUNG Nachtrag 5 in
              `zeitstrahlZeile.css`), faellt Chromium fuer den SICHTBAREN Ausschnitt auf
              Linksbuendigkeit zurueck - `text-align` hat dort schlicht keine Wirkung mehr. Der
              eigentliche Grund fuer die Span-Loesung ist Cross-Browser-Robustheit, nicht diese
              Chromium-Messung - siehe `.tlp-station-datum`-Kommentar in `zeitstrahlZeile.css`
              (Nachtrag 4/5) fuer die vollen Messwerte und die ehrliche Begruendung.
            */}
            <div className="tlp-station-datum">
              <span className="tlp-station-datum-text">{fmtDate(zeitpunkt) || "—"}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
